<script setup lang="ts">
import { ref } from 'vue'
import { FilterField, TableField } from "../../../../components/table/table";
import { Permission } from '../../../../types/auth'
import ListTemplate from "../../../../components/ui/common/ListTemplate.vue";
import CustomersForm from './CustomersForm.vue';
import { api } from '../../../../api/Api';
import { printPDFBlob } from '../../../../utils/CommonFunctions';
import Buttons from '../../../../components/ui/form/Buttons.vue';
import ImportCustomersExcel from './ImportCustomersExcel.vue';

withDefaults(defineProps<{
  showHeader?: boolean,
  showQuickTour?: boolean,
  showTitle?: boolean,
  showNextButton?: boolean
  permissions?: Permission[]
}>(), {
  showHeader: true,
  showQuickTour: true,
  showTitle: true
})

const endPoint = '/clients/revenue/master-data/customers/'
const title = 'Customers'
const selectedData = ref<any | null>(null)
const showForm = ref(false)
const formMode = ref<'create' | 'edit' | 'view' | 'showQuickView' | 'toggleStatus'>('view')
const refreshData = ref(false)

const permissions = ref<Permission[]>();

const fields: TableField[] = [  
  { name: 'name', caption: 'Name', sortable: true, fieldType: 'text' },
  { name: 'customer_type', caption: 'Customer Type', sortable: true, fieldType: 'text' },
  { name: 'tax_registration_no', caption: 'TIN #', sortable: true, fieldType: 'text' },
  { name: 'mobile', caption: 'Mobile', sortable: true, fieldType: 'text' },
  { name: 'price_list', caption: 'Price List', sortable: true, fieldType: 'text' },
  { name: 'credit_term', caption: 'Credit Term', sortable: true, fieldType: 'text' },
  { name: 'credit_limit', caption: 'Credit Limit', sortable: true, fieldType: 'number' },
  { name: 'available_limit', caption: 'Available Limit', sortable: true, fieldType: 'number' },
  { name: 'sales_rep', caption: 'Sales Rep', sortable: true, fieldType: 'text' },
  { name: 'state', caption: 'State', sortable: true, fieldType: 'text' },
  { name: 'city', caption: 'City', sortable: true, fieldType: 'text' },
  { name: 'active', caption: 'active', sortable: false, fieldType: 'status' },
]

const filterFields: FilterField[] = [
  {
    name: 'active',
    label: 'Status',
    type: 'select',
    value: '',
     options: [
      { id: "1", name: "Active" },
      { id: "0", name: "Inactive" },
    ],
  },
]

const changeMode = (
  mode: "create" | "edit" | "view" | "showQuickView" | "toggleStatus"
) => {
  formMode.value = mode;
  showForm.value = mode === "view" || mode === "edit" || mode === "create";
};

const handleData = (data : any) => {
  selectedData.value = data
}

const handleTableActions = async (action: string, data: { uid: any; }) => {
  if (action == 'statement') {
    const response = await api.post(
    (endPoint.slice(-1) == "/" ? endPoint : endPoint + "/") +
      "statement",
    {
      id: data.uid,
    }
  );
  if (response.success == true) {
    printPDFBlob(response.data);
  }
  }
}

const showImportExcel = ref(false);
</script>

<template>
  <ListTemplate :endPoint = "endPoint" :title = "title" :fields = "fields" :actions = "[
    { name: 'statement', icon: 'ScrollText', variant: 'primary', title: 'Statement', permission: 'View', dropdown: true, visible: () => true }
  ]" :filterFields ="filterFields" @custom="handleTableActions"
  :tabList = "[]" :refreshData = "refreshData" @mode="changeMode" @show="showForm = true" :showForm="showForm" 
  @data="handleData" :show-header="showHeader" :show-quick-tour="showQuickTour" :show-title="showTitle">
  <template #header-actions>
    <Buttons
      caption="Import Sales using Excel Files"
      icon="Import"
      @click="showImportExcel = true"/>
    </template>
  <template #form-view>
    <CustomersForm
      :permissions="permissions"
      v-if="showForm"
      :data="selectedData"
      :end-point="endPoint"
      :title="title"
      :mode="formMode"
      @save="refreshData = !refreshData"
      @close="showForm = !showForm"
    />
    <ImportCustomersExcel
    :endPoint="endPoint"
      v-if="showImportExcel"
      @close="showImportExcel = false"
    />
  </template>
  </ListTemplate>
</template>